import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  paperStyle: {
    padding: '6px',
    marginBottom: '10px',
  },
  dividerStyle: {
    height: '110px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textFlexCenter: {
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    justifyContent: 'space-around',
    textAlign: 'center',
    margin: '10px',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  addressDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    borderRight: '1px rgba(0,0,0,.3) solid',
  },
}));

export default styles;
